export default "__VITE_ASSET__585c0e04__"